import type { LoomSceneNode } from "./loomAuthoringModel";
import type { LoomWingSectionSide } from "./loomSectionRecipe";

/** Validate identity placement without confusing historical source state with the current head. */
export function validateLoomSectionRecipePlacements(documentId: string, nodes: readonly LoomSceneNode[]): void {
  nodes.forEach((node) => {
    if (node.type !== "primitive" || node.definition.primitive !== "wing") return;
    node.definition.panels.forEach((panel) => {
      (["root", "tip"] as const).forEach((side: LoomWingSectionSide) => {
        const source = panel.sectionRecipes?.[side]?.treatment?.source;
        if (!source) return;
        if (source.documentId !== documentId || source.nodeId !== node.id || source.panelId !== panel.panelId || source.side !== side) {
          throw new Error(`section treatment placement mismatch at ${documentId}/${node.id}/${panel.panelId}/${side}`);
        }
      });
    });
  });
}
